import { render, staticRenderFns } from "./CreateNewRewardForm.vue?vue&type=template&id=1963abe2&"
import script from "./CreateNewRewardForm.vue?vue&type=script&lang=ts&"
export * from "./CreateNewRewardForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports